module.exports = __webpack_public_path__ + "static/media/bpsu.logo.300w.bc340dec.jpg";